import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { SubscriberEntryNavigationModule } from 'store/modules/subscriber/subscriber-tasks/subscriberEntryNavigationModule';
import { OverlaySpinner } from '@insurancemenu/imenu-components-lib';
import SubscriberTask from 'components/subscriber/employee-profile/SubscriberTask';
import { EMPLOYEE_PROFILE_TEST_IDS } from '../../constants';
import {
  InactiveTasksWrapperStyled,
  NoTasksTitleStyled,
  SectionTitleStyled,
  SubscriberTasksListStyled,
  TasksWrapperStyled,
  SpinnerWrapperStyled,
} from './styles';

interface Props {
  subscriberEntryNavigationModule: SubscriberEntryNavigationModule;
}

const SubscriberTasks: React.FC<Props> = observer(({ subscriberEntryNavigationModule }) => {
  const {
    isLoading,
    showNoActiveTasks,
    domainData,
    getInitialData,
    getTaskChecklistPresenters,
    subscriberTasksDelegate,
  } = subscriberEntryNavigationModule;
  const { activeTasks, inactiveTasks } = subscriberTasksDelegate;

  useEffect(() => {
    void getInitialData();
  }, [domainData.groupId]);

  if (isLoading) {
    return (
      <SpinnerWrapperStyled data-test-id={EMPLOYEE_PROFILE_TEST_IDS.LOADING_SPINNER}>
        <OverlaySpinner display size="8rem" overlay="none" />
      </SpinnerWrapperStyled>
    );
  }

  return (
    <>
      {showNoActiveTasks && (
        <NoTasksTitleStyled data-test-id={EMPLOYEE_PROFILE_TEST_IDS.NO_ACTIVE_TASKS_MESSAGE}>
          No Active Tasks
        </NoTasksTitleStyled>
      )}

      {activeTasks.length > 0 && (
        <TasksWrapperStyled data-test-id={EMPLOYEE_PROFILE_TEST_IDS.ACTIVE_TASKS_SECTION}>
          <SubscriberTasksListStyled>
            {activeTasks.map((task) => (
              <SubscriberTask
                key={task.entityId}
                task={task}
                checklistOptions={getTaskChecklistPresenters(task.entityId)}
              />
            ))}
          </SubscriberTasksListStyled>
        </TasksWrapperStyled>
      )}

      {inactiveTasks.length > 0 && (
        <InactiveTasksWrapperStyled data-test-id={EMPLOYEE_PROFILE_TEST_IDS.INACTIVE_TASKS_SECTION}>
          <SectionTitleStyled>Inactive Tasks</SectionTitleStyled>
          <SubscriberTasksListStyled>
            {inactiveTasks.map((task) => (
              <SubscriberTask
                key={task.entityId}
                task={task}
                checklistOptions={getTaskChecklistPresenters(task.entityId)}
              />
            ))}
          </SubscriberTasksListStyled>
        </InactiveTasksWrapperStyled>
      )}
    </>
  );
});

export default SubscriberTasks;
